export default __webpack_public_path__ + "static/media/bariol_bold_italic-webfont.37d13e9e.woff";